var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex flex-column"},[_c('Accueil',{ref:"home"}),_c('Programme',{ref:"programme"}),_c('Intervenants',{ref:"intervenants"}),_c('PermisTronconneuse',{ref:"permis-tronconneuse"}),_c('InfosAcces',{ref:"acces"}),_c('GoogleMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }